import { g as a } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { createElementBlock as f, openBlock as s, normalizeClass as d, createElementVNode as e, createStaticVNode as t } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconO365Calendar",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (o) => Object.keys(r).includes(o)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = a();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], p = ["fill"], _ = ["fill"], B = /* @__PURE__ */ t('<g filter="url(#d)"><circle cx="10.213" cy="10.215" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#e)"><circle cx="10.213" cy="14.5" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#f)"><circle cx="10.213" cy="18.787" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#g)"><circle cx="5.93" cy="14.5" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#h)"><circle cx="5.93" cy="18.787" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#i)"><circle cx="14.499" cy="10.215" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#j)"><circle cx="18.786" cy="10.215" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#k)"><circle cx="14.499" cy="14.5" fill="#F2F2F2" r="1.071"></circle></g><g filter="url(#l)"><circle cx="18.786" cy="14.5" fill="#F2F2F2" r="1.071"></circle></g>', 9), x = { filter: "url(#m)" }, g = ["fill"], C = { filter: "url(#o)" }, F = ["fill"], S = /* @__PURE__ */ t('<filter id="d" x="5.714" y="6.858" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="e" x="5.714" y="11.143" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="f" x="5.714" y="15.43" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="g" x="1.43" y="11.143" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="h" x="1.43" y="15.43" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="i" x="9.999" y="6.858" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="j" x="14.286" y="6.858" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="k" x="9.999" y="11.143" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="l" x="14.286" y="11.143" width="11.286" height="11.286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="2.286"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="m" x="2.858" y="-1.429" width="12" height="13.429" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="1.143"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter><filter id="o" x="11.43" y="-1.429" width="12" height="13.429" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dx="1.143" dy="1.143"></feOffset><feGaussianBlur stdDeviation="2.286"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13091_975"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_13091_975" result="shape"></feBlend></filter>', 11), m = ["id"], y = /* @__PURE__ */ e("stop", { "stop-color": "#0667B8" }, null, -1), G = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#0E5399"
}, null, -1), M = [
  y,
  G
], O = ["id"], w = /* @__PURE__ */ e("stop", { "stop-color": "#28AFEA" }, null, -1), v = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#1797E0"
}, null, -1), I = [
  w,
  v
], A = ["id"], U = /* @__PURE__ */ e("stop", { "stop-color": "#3CCBF4" }, null, -1), k = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#3CCBF4"
}, null, -1), D = [
  U,
  k
], q = ["id"], R = /* @__PURE__ */ e("stop", { "stop-color": "#3CCBF4" }, null, -1), $ = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#3CCBF4"
}, null, -1), b = [
  R,
  $
], E = ["id"], z = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}, null, -1), H = [
  z
];
function j(o, L, l, N, V, i) {
  return s(), f("svg", {
    "aria-label": l.ariaLabel,
    class: d([i.iconSizeClass, "d-icon d-icon--o365-calendar"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "O365 Calendar",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${o.uniqueID}a)`
    }, [
      e("rect", {
        x: "2",
        y: "3.428",
        width: "20",
        height: "5.714",
        rx: "1.143",
        fill: `url(#${o.uniqueID}b)`
      }, null, 8, p),
      e("path", {
        d: "M2 7.715h20v13.143c0 .631-.512 1.143-1.143 1.143H3.143A1.143 1.143 0 0 1 2 20.858V7.715Z",
        fill: `url(#${o.uniqueID}c)`
      }, null, 8, _),
      B,
      e("g", x, [
        e("rect", {
          x: "6.286",
          y: "2",
          width: "2.857",
          height: "4.286",
          rx: "1.429",
          fill: `url(#${o.uniqueID}n)`
        }, null, 8, g)
      ]),
      e("g", C, [
        e("rect", {
          x: "14.858",
          y: "2",
          width: "2.857",
          height: "4.286",
          rx: "1.429",
          fill: `url(#${o.uniqueID}p)`
        }, null, 8, F)
      ])
    ], 8, h),
    e("defs", null, [
      S,
      e("linearGradient", {
        id: `${o.uniqueID}b`,
        x1: "2.714",
        y1: "4.143",
        x2: "22",
        y2: "7.714",
        gradientUnits: "userSpaceOnUse"
      }, M, 8, m),
      e("linearGradient", {
        id: `${o.uniqueID}c`,
        x1: "2.714",
        y1: "8.365",
        x2: "19.219",
        y2: "22.889",
        gradientUnits: "userSpaceOnUse"
      }, I, 8, O),
      e("linearGradient", {
        id: `${o.uniqueID}n`,
        x1: "7.715",
        y1: "2",
        x2: "7.715",
        y2: "6.286",
        gradientUnits: "userSpaceOnUse"
      }, D, 8, A),
      e("linearGradient", {
        id: `${o.uniqueID}p`,
        x1: "16.287",
        y1: "2",
        x2: "16.287",
        y2: "6.286",
        gradientUnits: "userSpaceOnUse"
      }, b, 8, q),
      e("clipPath", {
        id: `${o.uniqueID}a`
      }, H, 8, E)
    ])
  ], 10, c);
}
const K = /* @__PURE__ */ n(u, [["render", j]]);
export {
  K as default
};
//# sourceMappingURL=o365-calendar.js.map
